// extracted by mini-css-extract-plugin
export var center = "_1i-2";
export var clickableRow = "_1i-5";
export var expandedRow = "_1i-7";
export var hoverable = "_1i-4";
export var left = "_1i-1";
export var right = "_1i-3";
export var row = "_1i-0";
export var selectedRow = "_1i-6";
export var summaryRow = "_1i-8";